export const COMMUNICATIONS_SCOPE_TEXTS = {
  TITLE: 'Emails visible to an exposure-level assignment',
  NOTE: 'Only emails added to the claim on or after the assignment date. A general, claim-level assignment sees all the emails on the claim.',
  ALL_CLAIM: 'All emails on the claim',
  ASSIGNED_EXPOSURES: 'Only emails linked to the assigned exposures',
} as const;
